import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Settings, Zap, Cpu, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../translations/home';

const ServicesSection = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = homeTranslations[language].services;
  
  const services = [
    {
      icon: Settings,
      title: t.service1.title,
      description: t.service1.description,
      link: '/cnc',
      image: '/images/home/service-cnc.jpg'
    },
    {
      icon: Zap,
      title: t.service2.title,
      description: t.service2.description,
      link: '/harness',
      image: '/images/home/service-harness.jpg'
    },
    {
      icon: Cpu,
      title: t.service3.title,
      description: t.service3.description,
      link: '/automation',
      image: '/images/home/service-automation.jpg'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.title} <span className="text-[#B91C1C]">{t.titleAccent}</span>
          </h2>
          <div className="w-24 h-1 bg-[#B91C1C] mx-auto mt-4"></div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={index}
                className="relative overflow-hidden bg-gray-800/50 border-gray-700  backdrop-blur-sm group"
              >
                {/* Background Image with Overlay */}
                <div className="absolute inset-0 z-0">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover opacity-90 group-hover:opacity-95 transition-opacity duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/80 to-black/90"></div>
                </div>

                {/* Content */}
                <div className="relative z-10">
                  <CardHeader>
                    <div className="w-16 h-16 bg-gradient-to-br from-[#B91C1C]/30 to-gray-900/50 backdrop-blur-sm rounded-lg flex items-center justify-center mb-4 group-hover:from-[#B91C1C]/50  border border-[#B91C1C]/20">
                      <IconComponent className="text-[#B91C1C]" size={32} />
                    </div>
                    <CardTitle className="text-xl font-bold text-white mb-2">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-gray-300 mb-6 leading-relaxed">
                      {service.description}
                    </CardDescription>
                    <Button 
                      className="bg-[#B91C1C]/90 hover:bg-[#B91C1C] text-white border border-[#B91C1C] backdrop-blur-sm group/btn shadow-lg"
                      onClick={() => {
                        if (service.link.startsWith('/')) {
                          navigate(service.link);
                        } else {
                          document.querySelector(service.link)?.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      {t.learnMore}
                      <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform duration-300" size={16} />
                    </Button>
                  </CardContent>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
